import articles from './articles'
import feedback from './feedback'
import files from './files'
import questions from './questions'
import products from './products'
import users from './users'
import settings from './settings'

// AUTH
// ------------------------------
export const AUTH = {
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  REFRESH: '/auth/refresh',
  USER: '/auth/user'
}

// ARTICLES
// ------------------------------
export const ARTICLES = '/articles'

// FEEDBACK
// ------------------------------
export const FEEDBACK = '/feedback'

// FILES
// ------------------------------
export const FILES = '/files'

// PRODUCTS
// ------------------------------
export const PRODUCTS = '/products'

// QUESTIONS
// ------------------------------
export const QUESTIONS = '/questions'

// USERS
// ------------------------------
export const USERS = '/users'
export const USER_GROUPS = '/user-groups'

// SETTINGS
// ------------------------------
export const SETTINGS = '/settings'

export default {
  articles,
  feedback,
  files,
  questions,
  products,
  users,
  settings
}
